export enum ShipmentEventStatus {
  CREATED = 'CREATED',
  READY = 'READY',
  FAILED = 'FAILED',
}
